import { axiosWithKey } from "~/axios";
import { getToken } from "~/redux/user/tokens";
import _ from 'lodash'

const SEARCH_FILTER_ITEMS = "searchFilterItems";

export const toggler = (iArr, iStr) =>
  iArr.includes(iStr) ? iArr.filter(el => el !== iStr) : [...iArr, iStr];

export const getTags = (arr, str) =>
  arr.filter(t => t.tagType === str).map(t => ({ title: t.title }));

export const getFilterItemsFromClientStorage = () =>
  JSON.parse(window.sessionStorage.getItem(SEARCH_FILTER_ITEMS)) || {};

export const saveFilterItemsToClientStorage = items => {
  const currentItems = getFilterItemsFromClientStorage(),
    updatedItems = JSON.stringify({
      filterTags: {
        ...currentItems,
        ...items
      },
      expirationDate: Date.now() + 24 * 60 * 60 * 1000
    });
  window.sessionStorage.setItem(SEARCH_FILTER_ITEMS, updatedItems);
};

export const getCachedTags = () => {
  const filterItems = getFilterItemsFromClientStorage();
  const {
    filterTags,
    expirationDate
  } = filterItems;
  if (
    filterTags &&
    Date.now() < expirationDate
  ) {
    return {filterTags}
  } else {
    return null;
  }
};

export const fetchTags = () =>
  new Promise((resolve, reject) => {
    const { internalName } = window.settings;
    getToken(token => {
      return axiosWithKey({
        method: "GET",
        url: `fitness/all-equipment?site=${internalName}`,
        headers: { Authorization: token }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  });
